import React from 'react';
import Ellipse from '@splunk/dashboard-visualizations/Ellipse';

export default () => <Ellipse />;
